import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { interval, Subject } from 'rxjs';
import { startWith, switchMap, takeUntil } from 'rxjs/operators';
import { ConfirmationComponent } from '../../../../../src/app/shared/dialogs/confirmation/confirmation.component';
import { TeamConfigComponent } from '../../../../../src/app/shared/dialogs/team-config/team-config.component';
import { DataService } from '../../../../../src/app/shared/services/data.service';
import { LoaderService } from '../../../../../src/app/shared/services/loader/loader.service';
import { ResponseData, TeamGroup } from '../../../../../src/app/shared/services/teacher.interface';

@Component({
  selector: 'app-join-team',
  templateUrl: './join-team.component.html',
  styleUrls: ['./join-team.component.scss']
})
export class JoinTeamComponent implements OnInit {

  canStartQuiz = false;
  sessionIdData = sessionStorage.getItem('GCTeamId');
  groupId = this.sessionIdData ? this.sessionIdData : '';
  groupData : TeamGroup;
  canEditQuizConfig = false;

  private stopPolling$ = new Subject<void>(); // Subject to stop polling
  private isPolling = false; // To prevent multiple polling instances

  constructor(private dialog: MatDialog,
    private loader : LoaderService,
    private dataService: DataService,
    private router:Router
  ) {}

  ngOnInit(): void {
    this.getTeamGroup()
    this.startPolling();
  }

  startPolling() {
    if (this.isPolling) return; // Prevent multiple polling instances
    this.isPolling = true;

    interval(5000)
      .pipe(
        startWith(0),
        takeUntil(this.stopPolling$), 
        switchMap(() => this.dataService.getTeamGroup(this.groupId))
      )
      .subscribe({
        next: (res: ResponseData<TeamGroup>) => {
          this.canEditQuizConfig = res.data.start_time ? false : true
          this.groupData = res.data;
          this.canStartQuiz = res.data.is_enable
          sessionStorage.setItem('GCQrCode', res.data.qr_code);
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
        }
      });
  }

  getTeamGroup(){
    this.loader.display(true);
    this.dataService.getTeamGroup(this.groupId).subscribe({
      next:(res:ResponseData<TeamGroup>) =>{
        this.groupData = res.data;
        sessionStorage.setItem('GCQrCode',res.data.qr_code)
        this.loader.display(false);
      },
      error:(err:HttpErrorResponse) =>{
        console.log(err);
        this.loader.display(false);
      },
    })
  }

  editQuizSettings(){
    //if quiz started can't edit the quiz configuration
    if(this.canEditQuizConfig){
      const dialogRef = this.dialog.open(TeamConfigComponent, {
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((data:boolean)=>{
        console.log(data)
        if(data){
          this.getTeamGroup();
        }
      })
    }
    }

    CopyQrLink(link:string){
      navigator.clipboard.writeText(link).then(()=>{
        this.dataService.customSnackBar("Link copied!","","success",2500);
      }).catch(()=>{
        console.error('error on copy link');
      })
    }   

    startQuiz(){
      const dialogRef = this.dialog.open(ConfirmationComponent, {
        disableClose: true,
        data: {isTeacher:true,isStart:true}
      });
      dialogRef.afterClosed().subscribe((data:boolean)=>{
        if(data){
          let params = {
            start_time : Math.floor(Date.now() / 1000)
          }
          this.stopPolling();
          this.dataService.startQuiz(this.groupId,params).subscribe({
            next:(res:ResponseData<TeamGroup>) =>{
              if(res.data.is_active){
                // console.log(res.data);
                // let endTime = Math.floor(Number(res.data.end_time))
                // sessionStorage.setItem('end_time',endTime.toString());
                this.router.navigateByUrl('/leaderboard')
              }
            },
            error:(err:HttpErrorResponse) =>{
              console.log(err);
            },
          })
        }
      })
    }

    clearQuizConfig(){
      const dialogRef = this.dialog.open(ConfirmationComponent, {
        disableClose: true,
        data: {isTeacher:true}
      });
      dialogRef.afterClosed().subscribe((data:boolean)=>{
        if(data){
          let params = {
            status : 104
          }
          this.dataService.startQuiz(this.groupId,params).subscribe({
            next:(res:ResponseData<TeamGroup>) =>{
              if(res.data){
                this.stopPolling();
                this.router.navigateByUrl('/category')
              }
            },
            error:(err:HttpErrorResponse) =>{
              this.stopPolling();
              console.log(err);
            },
          })
        }
      })
      
    }

    // Stop polling
  stopPolling() {
    this.isPolling = false;
    this.stopPolling$.next(); // Trigger the stop signal
  }

  // Cleanup on component destroy
  ngOnDestroy(): void {
    this.stopPolling(); // Stop polling when component is destroyed
    this.stopPolling$.complete();
  }
}
